export const LOGIN_LABELS = {
  login: 'Login',
  newEmployees: 'New\nEmployees',
  beginI9: 'CLICK HERE TO BEGIN YOUR I-9',
  employerLogin: 'Employer\nAccount Login',
  accountId: 'Account ID',
  password: 'Password',
  email: 'Email',
  btnLogin: 'Login',
  divider: 'OR',
  success: 'Login successful! Token: ',
  emailRequired: 'Email address is required',
  passwordRequired: 'Password is required',
  accountIdRequired: 'Account ID is required',
  invalidEmail: 'Please enter a valid email address',
};
